<template>
  <div>
    <caption class="caption table-caption">Add deal for all users</caption>
    <b-row>
      <b-col offset="3" cols="9" class="d-flex flex-row justify-content-end">
        <b-form-select v-model="dealToAssign" :options="deals" :disabled="deals.length == 0"/>
      </b-col>
    </b-row>
    <b-row>
      <b-col offset="3" cols="9" class="d-flex flex-row justify-content-between">
        <b-btn variant="info" @click="assignDealToAllUsers" :disabled="dealToAssign.length == 0" class="mt-1 mb-1">Assign to all users</b-btn>
        <b-btn variant="outline-info" @click="deleteDealFromAllUsers" :disabled="dealToAssign.length == 0" class="mt-1 ml-1 mb-1">Remove from all users</b-btn>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import service from '../../services/HttpRequestService';

import { UserNotifications, withUINotification } from '../../hooks/UserNotifications';

export default {
  props: ['deals', 'users'],
  data() {
    return {
      dealToAssign: ''
    };
  },
  methods: {
    async assignDealToAllUsers() {
      await withUINotification.bind(this)(async () => {
        await service.assignDealToAll(this.dealToAssign);
        this.dealToAssign = '';
        UserNotifications.UserChanged(user.Id).emit(this)
      },
      `Failed to assign ${this.dealToAssign} to all users.`,
      `The deal ${this.dealToAssign} has been assigned to all users.`);
    },

    async deleteDealFromAllUsers() {
      await withUINotification.bind(this)(async () => {
        await service.removeDealFromAll(this.dealToAssign);
        this.dealToAssign = '';
        UserNotifications.UserChanged(user.Id).emit(this)
      },
      `Failed to unassign the ${this.dealToAssign} to all users.`,
      `The deal ${this.dealToAssign} has been unassigned to all users.`);
    }
  }
};
</script>

<style lang="scss" scoped>
.table-caption {
 display: inline-block;
 width: 100%;
 margin: 10px 0px;
}
</style>